<template>
  <section id="calendar-sheet__section--media">
    <template
      v-if="routedDay.calendarSheetLinks.length || routedDay.songs.length"
    >
      <!-- Links -->
      <calendar-sheet-links />
      <!-- Songs -->
      <calendar-sheet-songs />
    </template>
    <calendar-sheet-video
      v-else-if="
        routedDay.videos.length && routedDay.videos[0].videoFile?._rendered
      "
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import CalendarSheetLinks from "./media/CalendarSheetLinks.vue";
import CalendarSheetSongs from "./media/CalendarSheetSongs.vue";
import CalendarSheetVideo from "./media/CalendarSheetVideo.vue";

export default {
  name: "CalendarSheetMedia",
  components: {
    CalendarSheetVideo,
    CalendarSheetLinks,
    CalendarSheetSongs,
  },
  computed: {
    ...mapGetters(["routedDay"]),
  },
};
</script>
